/*
  Flavour pickers: keep keyboard focus in place and say what changed.
  (DTC-149, DTC-148; WCAG 2.4.3, 4.1.3)

  Every flavour picker in the theme has the same shape: an "Add+" button
  (.btn--add) that hides once the flavour is in, and a .qty-picker with
  remove / quantity / add-another. Pressing Add hid the focused button, so
  focus fell to <body> and a keyboard user was thrown back to the top of the
  page; nothing told a screen reader the bundle or the price had changed.

  This listens for those clicks (Enter and Space on a button are clicks), lets
  Alpine re-render, then:
    - after Add, focuses "Add another {flavour}";
    - when a flavour goes back to 0, focuses its Add button again;
    - announces e.g. "Classic Variety Pack added. 2 bags in your bundle,
      Save 20%. Total $67.90." in one polite live region.
  It reads the component's own rendered text, so it needs no changes in the
  six Alpine components it serves.
*/
(() => {
  let region;
  function say(text) {
    if (!region) {
      region = document.createElement('div');
      region.className = 'patrol-sr-only';
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('aria-atomic', 'true');
      document.body.appendChild(region);
    }
    region.textContent = '';
    setTimeout(() => { region.textContent = text; }, 60);
  }
  const visible = (el) => !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  const clean = (s) => (s || '').replace(/\s+/g, ' ').trim();

  function rowOf(el) {
    let row = el;
    while (row && row !== document.body && !(row.querySelector('.btn--add') && row.querySelector('.qty-picker'))) row = row.parentElement;
    return row && row !== document.body ? row : null;
  }

  function bundleSummary(from) {
    const root = from.closest('[x-data]');
    if (!root) return '';
    const parts = [];
    const total = [...root.querySelectorAll('input.qty-picker__input')].reduce((n, i) => n + (parseInt(i.value, 10) || 0), 0);
    if (total) parts.push(`${total} ${total === 1 ? 'bag' : 'bags'} in your bundle`);
    const reached = [...root.querySelectorAll('.product__progress-checkpoint--active')].pop();
    const saving = reached && clean(reached.closest('.product__progress-item')?.querySelector('.text-nectar-green')?.textContent);
    if (saving) parts.push(saving);
    const cta = root.querySelector('#add-to-cart, .product__cta-btn');
    if (cta) {
      const prices = [...cta.querySelectorAll('span')].filter((s) => visible(s) && !s.classList.contains('line-through') && /\$\s?\d/.test(s.textContent));
      if (prices.length) parts.push(`Total ${clean(prices[prices.length - 1].textContent)}`);
    }
    return parts.join(', ');
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.btn--add, .qty-picker__btn');
    if (!btn || btn.closest('.mini-cart')) return;
    const row = rowOf(btn);
    if (!row) return;
    const addBtn = row.querySelector('.btn--add');
    const name = clean((addBtn.getAttribute('aria-label') || '').replace(/^Add\s+/, '')) || 'Item';
    const wasAdd = btn.classList.contains('btn--add');
    setTimeout(() => {
      const qty = parseInt(row.querySelector('.qty-picker__input')?.value, 10) || 0;
      if (wasAdd) {
        const more = [...row.querySelectorAll('.qty-picker__btn')].pop();
        if (visible(more)) more.focus();
      } else if (qty === 0 && visible(addBtn)) {
        addBtn.focus();
      }
      const summary = bundleSummary(row);
      const what = qty === 0 ? `${name} removed.` : (wasAdd ? `${name} added.` : `${name}: ${qty}.`);
      say(summary ? `${what} ${summary}.` : what);
    }, 80);
  }, true);
})();
